(function() {
  'use strict';

  angular
    .module('directives.verticalTray', [])
    .directive('mfVerticalTray', mfVerticalTray);

  mfVerticalTray.$inject = ['HM_OPTION_DEFAULTS'];

  function mfVerticalTray(HM_OPTION_DEFAULTS) {
    return function(scope, elem, attrs) {
      var target = angular.element(attrs.mfVerticalTray);
      var maxHeight = parseInt(target.css('maxHeight'));
      var minHeight = parseInt(target.css('minHeight'));
      var halfHeight = (maxHeight + minHeight) / 2;
      var timer;

      var defaults = _.defaults({
        prevent_default: true,
        swipe: false,
        drag: true,
        drag_vertical: true,
        drag_horizontal: false,
        drag_min_distance: 2,
        transform: false,
        tap: true,
        tap_max_interval: 100,
        hold: false
      }, HM_OPTION_DEFAULTS);

      scope.$watch(attrs.closeTray, function(newValue) {
        if (!newValue) return;
        clearTimeout(timer);
        timer = setTimeout(snapToOpen.bind(null, false), 2000);
      });

      // TODO: do some testing
      //scope.$watch(attrs.openTray, function (newValue) {
      //  if (!newValue) return;
      //  clearTimeout(timer);
      //  timer = setTimeout(snapToOpen.bind(null, true), 1000);
      //});

      elem.hammer(defaults, 'tap').on('tap', toggleOpen);

      scope.$on('$destroy', function() {
        elem.off();
      });

      function toggleOpen() {
        clearTimeout(timer);
        snapToOpen(getCurrentHeight() < halfHeight);
      }

      function snapToOpen(toOpen) {
        toOpen ? target.addClass('trayOpen') : target.removeClass('trayOpen');

        target.stop(true).animate({
          height: toOpen ? maxHeight : minHeight
        }, 250);
      }

      function getCurrentHeight() {
        return parseInt(target.css('height'));
      }
    };
  }
})();
